<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex v-if="loading == true" lg12>
        <h2 style="padding-top: 10%;"><center>Loading Details<br /><span style="font-size: 12px;">Please Wait</span></center></h2>
      </v-flex>
      <v-flex lg12 v-if="loading == false">
        <label class="blackLabel" v-if="popupStatus.length > 0">Select Updated Status</label>
        <v-select @input="fncCheckUpdate" v-if="popupStatus.length > 0" class="colorSelect" style="width: 30%" :items="popupStatus" v-model="newStatus" label="Select Status" item-value="text" autocomplete solo></v-select>
        <br />
        <label class="blackLabel">Reason for Status Change</label>
        <v-text-field rows="3" multi-line clearable label="Enter your reason here" v-model="additionalComments" solo></v-text-field>
      </v-flex>
      <div class="pl-4 pr-1 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
          <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
          <v-btn v-if="popupStatus.length > 0" :disabled="!canUpdate" color="success" class="text-xs-right" @click.stop="fncUpdateReportStatus()">Update</v-btn>
          <v-btn v-if="popupStatus.length == 0" color="success" class="text-xs-right" @click.stop="fncUpdateReportStatus()">Update</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Settings',
    data () {
      return {
        loading: true,
        popupStatus: [],
        newStatus: '',
        isAddValid: false,
        isDiff: false,
        runAdd: false,
        objUser: 0,
        test: '',
        additionalComments: '',
        canUpdate: false
      };
    },
    methods: {
      fncCheckUpdate() {
        if( this.newStatus == this.globalModalParams.saleReport.status ) {
          this.canUpdate = false;
        } else {
          this.canUpdate = true;
        }
      },
      fncHideModal () {
        this.$store.commit('hideModal');
      },
      fncCheckComment(comment) {
        if( comment === '' ) {
          return 'No Comment';
        } else {
          return comment;
        }
      },
      fncUpdateReportStatus() {
        if( this.popupStatus.length > 0 ) {

          var id = 0;
          for( var s in this.popupStatus ) {
            if( this.newStatus == this.popupStatus[s].text ) {
              id = this.popupStatus[s].id;
            }
          }

          this.$store.dispatch({
            type: 'fncUpdateReportStatus',
            statusId: id,
            comment: this.additionalComments,
            quoteId: this.globalModalParams.saleReport.quoteId,
            vendorId: this.globalModalParams.saleReport.vendor,
            saleReport: this.globalModalParams.saleReport,
            doPrint: this.globalModalParams.doPrint
          })
        } else {
          this.$store.dispatch({
            type: 'fncUpdateReportStatus',
            statusId: this.globalModalParams.statusId,
            comment: this.additionalComments,
            quoteId: this.globalModalParams.saleReport.quoteId,
            vendorId: this.globalModalParams.saleReport.vendor,
            saleReport: this.globalModalParams.saleReport,
            doPrint: this.globalModalParams.doPrint
          })
        }
      },
      fncCheckStatus() {
        if( this.globalModalParams.currentStatus === this.globalModalParams.currentStatusStatic ) {
          this.isAddValid = false;
          this.isDiff = false;
        } else {
          this.isAddValid = true;
          this.isDiff = true;
        }
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'statusListDropdown'
      ])
    },
    beforeMount() {
      if( this.globalModalParams.doPrint != undefined && this.globalModalParams.doPrint != null && this.globalModalParams.doPrint == true ) {
        this.$store.dispatch({
          type: 'fncUpdateReportStatus',
          statusId: this.globalModalParams.statusId,
          comment: 'Updated from print button',
          quoteId: this.globalModalParams.saleReport.quoteId,
          vendorId: this.globalModalParams.saleReport.vendor,
          saleReport: this.globalModalParams.saleReport
        })
      }
    },
    mounted() {
      if( this.globalModalParams.statusList ) {
        var mainThis = this;
        setTimeout(function(){
          mainThis.loading = false;
          mainThis.newStatus = mainThis.globalModalParams.saleReport.status;
          for( var s in mainThis.globalModalParams.statusList ) {
            mainThis.popupStatus.push({id: mainThis.globalModalParams.statusList[s].id, 'text': mainThis.globalModalParams.statusList[s].description});
          }
        }, 1500)
      } else {
        this.loading = false
      }
    }
  }
</script>

<style scoped>
  /*@import '../../assets/css/shared.css'*/
</style>
